import { useState } from 'react';

import type { StoreSwitcherShoppingPreferences } from '@jane/bloom/types/schemas/bloom/storeSwitcher';

interface UseStoreSwitcherSearchStateArgs {
  initialShoppingPreferences: StoreSwitcherShoppingPreferences;
}

/**
 * Used to filter & sort the stores shown while searching. These are intermediate
 * filtering preferences before they are committed to a cookie, when pinning the store.
 */
export const useStoreSwitcherSearchState = ({
  initialShoppingPreferences,
}: UseStoreSwitcherSearchStateArgs) => {
  const [shoppingPreferences, setShoppingPreferences] =
    useState<StoreSwitcherShoppingPreferences>(initialShoppingPreferences);

  const updateShoppingPreferences = (
    updates: Partial<StoreSwitcherShoppingPreferences>
  ) => {
    setShoppingPreferences({
      ...shoppingPreferences,
      ...updates,
    });
  };

  return {
    shoppingPreferences,
    updateShoppingPreferences,
  };
};
